import { useState } from "react";
import { Provider } from "react-redux";
import Navbar from "./components/Navbar/Navbar";
import Home from "./Pages/Home";
import store from "./Redux/store";

function App() {
  const [show, setShow] = useState(true);
  return (
    <>
      <Provider store={store}>
        <Navbar setShow={setShow} />
        <Home show={show} />
      </Provider>
    </>
  );
}

export default App;
